import React, { useState, useEffect } from 'react';
import CheckModal from '../checkModal';
import { Ticket } from '@phosphor-icons/react';
import { analyticEventLogger } from '../../../../utils/commonUtils';
import { SELLER_FLOW_PROCEED_EVENT_CLICK } from '../../../../constants/eventLogger';

const Step42 = ({ isOpen, onConfirm, onClose }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [isModalOpen, setIsModalOpen] = useState(isOpen);

  useEffect(() => {
    setIsModalOpen(isOpen);
  }, [isOpen]);

  const handleCloseModal = () => {
    setIsModalOpen(false);
    onClose(); // Call the onClose prop to trigger the necessary parent actions
  };

  const handleCtaClick = () => {
    analyticEventLogger(SELLER_FLOW_PROCEED_EVENT_CLICK, { termsChecked: false });
    console.log('I have forwarded clicked');
    setIsModalOpen(false);
    onConfirm(); // Call the onConfirm prop to trigger the necessary parent actions
  };

  return (
    <div>
      <CheckModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        header='Wohoo! Almost there ✨'
        infocard={
          <div className='flex gap-3 items-center'>
            <div className='p-3'>
              <Ticket color='#FF2459' 
                size={24} />
            </div> 
            <div className='text-14'>
              Make sure you transfer the tickets instead of screenshots.{' '}
              <a className='text-primary text-14 underline' 
                href='https://linktr.ee/take_my_tickets'
                target='blank'>
                Learn how to transfer tickets.
              </a>
            </div>
          </div>
        }
        onCtaClick={handleCtaClick}
        ctaContent="List My Tickets"
        checkContent={
          <div className='text-14 text-grey-70'>
            I acknowledge and accept the{' '}
            <a href='/terms-and-conditions' 
              target='_blank' 
              className='text-black underline'>
              Terms of service
            </a>{' '}
            and{' '}
            <a href='/privacy-policy' 
              target='_blank' 
              className='text-black underline'>
              Privacy policy
            </a>. I confirm to transfer tickets to the buyer upon payment; non-compliance may result in legal action.
          </div>
        }
      />
    </div>
  );
};

export default Step42;
